export const DEFERRED_RESOURCE_STALE_TIME = Infinity;

export function deferredResourceQueryOptions<TOptions extends object>(
  options: TOptions,
): TOptions & { staleTime: number } {
  return {
    ...options,
    staleTime: DEFERRED_RESOURCE_STALE_TIME,
  };
}
